module.exports = __webpack_public_path__ + "static/bitwa1920-d2cd173a65e4c82667ad974160009498.png";